<template>
  <div id="all" class="animated fadeIn">
    
    <!-- (Grafik bar total penjualan CRO per Box) -->
    <!-- nama variabel: total_box_sold_cro -->
    <b-card id="spkb-generated-bar">
      <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">
            Total SPKB Generated
          </h4>
          <div class="small text-muted">
            {{ currentMonth + " " + currentYear }}
          </div>
        </b-col>
      </b-row>
      <bar-example
        v-if="!loading"
        :key="uniqueId('bar-cro-2')"
        :bar-label="total_spkb_generated.label"
        :bar-data="total_spkb_generated.dataset"
        chartId="chart-doughnut-02"
        :height="isMobile"
      ></bar-example>
      <loading v-else></loading>
    </b-card>

    <b-card-group class="mb-4">
      <b-card class="col-sm-12 col-md-4 col-lg-4">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;SPKB Generated based on Status
        </div>
        <div class="small text-muted text-right mb-4">
          Total SPKB yang telah dibuat berdasarkan status SPKB
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('spkb_status')"
            :doughnut-label="spkb_status.label"
            :doughnut-data="spkb_status.data"
            chartId="spkb_status"
          ></doughnut-example
          ><br />
          <table-total
            :tableData="spkb_status"
            :title="'spkb_status'"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>

      <b-card class="col-sm-12 col-md-4 col-lg-4">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;SPKB Generated based on Source
        </div>
        <div class="small text-muted text-right mb-4">
          Total SPKB yang telah dibuat berdasarkan sumber pembuatan SPKB
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('spkb_source')"
            :doughnut-label="spkb_source.label"
            :doughnut-data="spkb_source.data"
            chartId="spkb_source"
          ></doughnut-example
          ><br />
          <table-total
            :tableData="spkb_source"
            :title="'spkb_source'"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
    </b-card-group>

     <b-modal
        ref="myModalRef"
        id="showDetail"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        hide-footer
        size="lg"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">{{title_show_detail}}</h3>
        </div>

        <div v-if="!loading">
          <b-row>
              <b-col sm="6" lg="2">
                <b-form-group label-for="today" label="Tanggal">
                  <model-select
                    id="today"
                    :options="listToday"
                    v-model="today"
                    @input="setToday"
                    placeholder="Today"
                  ></model-select>
                </b-form-group>
              </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <table class="attendance table-bordered">
                <tr
                  style="width:100%"
                  v-bind:class="{ green: index % 2 === 0 }"
                  v-for="(value, key, index) in data_detail[today]"
                  :key="uniqueId(key)"
                  :title="value"
                >
                  <td width="80%">
                    <div >{{ key }}</div>
                  </td>
                  <td width="20%" class="text-right">
                    {{ formatPrice(value) }}
                  </td>
                </tr>
              </table><br/>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <div class="float-right">
                <b-button type="button" size="sm" variant="danger" @click="closeDetail">
                  <i class="fa fa-undo"></i> Back
                </b-button>
              </div>
             </b-col>
          </b-row>
        </div>

        <div v-else>
          <loading></loading>
        </div>
      </b-modal>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import VueNotifications from "vue-notifications";
import loading from "@/templates/Loading.vue";
import LineExample from "@/views/charts/LineExample.vue";
import DoughnutExample from "@/views/charts/DoughnutExample.vue";
import BarExample from "@/views/charts/BarExample.vue";
import * as moment from "moment";
import { ModelSelect } from "vue-search-select";
import tableTotal from "@/templates/TableTotal.vue";

import _ from "lodash";

export default {
  name: "dashboard-cro",
  components: {
    globalTable,
    Callout,
    loading,
    ModelSelect,
    LineExample,
    DoughnutExample,
    BarExample,
    tableTotal
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      total_spkb_generated:[],
      spkb_status:[],
      spkb_source:[],
      loading: true,
      loading_suggest_visit: true,
      currState: 0,
      listMonth: [],
      listYear: [],
      listEmployee: [],
      listToday: [],
      listCustomerGroup: [],
      transaction_cro: [],
      transaction_box_cro: [],
      data_detail: [],
      today: moment().format("DD"),
      year: moment().format("YYYY"),
      month: moment().format("MM"),
      myId: "all", //localStorage.getItem("employee_id"),
      myCustomerGroup: "2",
      title_show_detail: "",
      showCustomerID: null,
      showCustomerGroupID: null,
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MMMM"),
      // fields_suggest_visit: [
      //   { key: "name", label: "Nama Konsumen", sortable: true },
      //   {
      //     key: "last_order_date",
      //     label: "Last Order",
      //     class: "width-150",
      //     sortable: true
      //   }
      // ],
      // fields_myorder: [
      //   { key: "order_number", label: "Order Number", sortable: true },
      //   { key: "total_price_plan", label: "Total", sortable: true }
      // ]
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  computed: {
    openTotalAll() {
      const division = localStorage.getItem("division_id");
      const position = localStorage.getItem("position_id");
      const allow_division = ["13", "4", "2", "10", "12", "16"];
      const allow_position = ["52", "18", "2", "19", "23", "59", "62", "12", "67"];
      return allow_division.includes(division) &&
        allow_position.includes(position)
        ? true
        : false;
    },
    showExcel() {
      const division = localStorage.getItem("division_id");
      const position = localStorage.getItem("position_id");
      const allow_division = ["13", "9", "16"];
      const allow_position = ["52", "14", "67"];
      return allow_division.includes(division) &&
        allow_position.includes(position)
        ? true
        : false;
    },
    showName() {
      let name = "";
      this.listEmployee.forEach((v, k) => {
        if (v.value === this.showCustomerID) {
          name = v.text;
        }
      });
      return name;
    },
    showCustomerGroup() {
      let flag = "";
      this.listCustomerGroup.forEach((v, k) => {
        if (v.value === this.showCustomerGroupID) {
          flag = v.text;
        }
      });
      return flag;
    },
    //menampilkan tipe tanggal order terakhir (order 1 minggu terakhir, 2 minggu terakhir, etc)
    showLastOrderType() {
      let flag = "";

      //mengapa switch? karena penulisan deskripsinya kalau ambil langsung dari labelnya ntar yg bacanya mabok
      switch (this.currState) {
        case 0:
          flag = "minggu ini order";
          break;
        case 1:
          flag = "1 minggu terakhir order";
          break;
        case 2:
          flag = "2 minggu terakhir order";
          break;
        case 3:
          flag = "belum order lebih dari 2 minggu";
          break;
        default:
          flag = "";
      }

      // for (let i in this.task_periode.label) {
      //   if (i == this.currState) {
      //     flag = this.task_periode.label[i];
      //   }
      // }

      return flag;
    },
    isMobile: function() {
      let check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      if (check === true) {
        if (window.screen.width < 732) {
          return undefined;
        } else {
          return 100;
        }
      } else {
        return 100;
      }
    }
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    init: function() {
      this.loading = true;
      this.loading_suggest_visit = true;
      this.showCustomerGroupID = this.myCustomerGroup;
      this.showCustomerID = this.myId;
      this.currentYear = moment(this.year + "-" + this.month + "-01").format(
        "YYYY"
      );
      this.currentMonth = moment(this.year + "-" + this.month + "-01").format(
        "MMMM"
      );
      this.axios
        .get(
          "web/dashboard/spkb/all-dashboard-for-spkb-generated/" +
            this.month +
            "/" +
            this.year +
            "/" 
        )
        .then(response => {
          this.total_spkb_generated = response.data.total_spkb_generated;
          this.spkb_status = response.data.spkb_status;
          this.spkb_source = response.data.spkb_source;

          let temp = [];
          temp.push(this.total_spkb_generated.dataset);
          this.total_spkb_generated.dataset = temp;

          
          // this.showDetail(3);
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
          this.loading_suggest_visit = false;
        });
    },
    dropdown: function() {
      this.axios
        .get("web/dropdown/dashboard-cro/")
        .then(response => {
          this.listMonth = response.data.month;
          this.listYear = response.data.year;
          this.listEmployee = response.data.employee;
          this.listCustomerGroup = response.data.customer_group;
        })
        .catch(error => {})
        .finally(() => {
          //this.loading = false;
        });
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Dashboard Sales",
          message: error.response.data.message
        });
      }
    },
    showDetail: function(state) {
      this.loading_suggest_visit = true;
      this.currState = state;
      this.axios
        .get(
          "web/dashboard/suggest-visit/" +
            state +
            "/" +
            this.myCustomerGroup +
            "/"
        )
        .then(response => {
          this.suggest_visit = response.data.suggest_visit;
        })
        .catch(error => {})
        .finally(() => {
          this.loading_suggest_visit = false;
        });
    },
    download: function() {
      this.loading_suggest_visit = true;
      this.axios({
        url:
          "web/export/customer/customer-last-order/" +
          this.currState +
          "/" +
          this.myCustomerGroup +
          "/",
        method: "GET",
        responseType: "arraybuffer" //before "blob"
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "customer_last_order.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loading_suggest_visit = false;
        });
    },
    openDetail: function(temp) {
      if(temp === 'transaction_box') {
        this.title_show_detail = "Jumlah RO / CRO";
        this.data_detail = this.transaction_box_cro;
      } else {
        this.title_show_detail = "Jumlah transaksi / CRO";
        this.data_detail = this.transaction_cro;
      }
      this.today = moment().format("DD");
      this.$refs.myModalRef.show();
    },
    closeDetail: function() {
      this.title_show_detail = '';
      this.data_detail = [];
      this.$refs.myModalRef.hide();
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    setToday: function(event) {
      this.today = event;
    }
  },
  mounted() {
    this.dropdown();
    this.init();
  }
};
</script>

<style></style>
